import React from 'react';
import { useParams } from 'react-router-dom';
import {
  Alert,
  AlertIcon,
  Stack,
  Flex,
  Image,
  Box,
  Text,
  Link
} from '@chakra-ui/react';
import { FaEnvelope, FaBell, FaSignal, FaFacebookF } from 'react-icons/fa';
import get from 'lodash/get';
import styled from '@emotion/styled';

import { useGetAnunciante } from 'actions/anunciantes';
import { DisplayText } from 'components/ui';
import { useDocumentTitle, usePermissao } from 'customHooks';

import AcoesButton from './AcoesButton';
import Tabs from './Tabs';

const Banner = styled(Flex)`
  background-color: #f5f5f5;
  border-color: #e3e3e3;
`;

Banner.defaultProps = {
  direction: 'row',
  align: 'start',
  boxShadow: 'inner',
  borderRadius: 'md',
  border: '1px',
  padding: 4
};

const Avatar = styled(Image)`
  background-color: white;
  border-color: rgba(0, 0, 0, 0.2);
`;

Avatar.defaultProps = {
  p: 1,
  boxShadow: 'sm',
  border: '1px',
  boxSize: '100px',
  fallbackSrc: '/static/img/pessoa/default.jpg'
};

const IconText = ({ icon, to, children, ...rest }) => {
  if (!children) return null;

  return (
    <Flex align="center" {...rest}>
      <Box as={icon} mr={1} />
      {to ? (
        <Link color="blue.500" target="_blank" href={to}>
          {children}
        </Link>
      ) : (
        children
      )}
    </Flex>
  );
};

const Anunciante = () => {
  const { id } = useParams();
  const { data: anunciante, status, error } = useGetAnunciante(id);
  useDocumentTitle(status === 'success' ? anunciante.data.nome : 'Anunciante');
  const { isLoading, value } = usePermissao('anunciante.change_anunciante');

  if (status === 'loading' || isLoading) return <DisplayText>Carregando...</DisplayText>;

  if (status === 'error')
    return <DisplayText>{get(error, 'response.data.detail')}</DisplayText>;

  const {
    ativo,
    foto_url,
    nome,
    numero,
    facebook,
    email,
    telefone,
    celular
  } = anunciante.data;

  return (
    <Stack spacing={4} p={4}>
      {!ativo && (
        <Alert status="info">
          <AlertIcon />
          Essa anunciante está desativada.
        </Alert>
      )}
      <Banner>
        <Avatar src={`${foto_url}`} alt={nome} />
        <Stack spacing={1} px={4} py={2}>
          <Text fontSize="2xl" fontWeight="bold">
            {nome}
          </Text>
          <Text color="gray.400" fontSize="sm">{`Anunciante nº${numero}`}</Text>
          <Stack spacing={4} isInline>
            <IconText
              fontSize="sm"
              icon={FaFacebookF}
              to={`https://www.facebook.com/${facebook}`}
            >
              {facebook}
            </IconText>
            <IconText fontSize="sm" icon={FaEnvelope}>
              {email}
            </IconText>
            <IconText fontSize="sm" icon={FaBell}>
              {telefone}
            </IconText>
            <IconText fontSize="sm" icon={FaSignal}>
              {celular}
            </IconText>
          </Stack>
        </Stack>
        {value && <AcoesButton anunciante={anunciante.data} />}
      </Banner>
      <Tabs permission={value} anunciante={anunciante.data} />
    </Stack>
  );
};

export default Anunciante;
